import * as React from 'react';
import * as styles from './styles.css';
import { ArticleHeading1, ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { IHouseInfoItemV2Schema } from '../../repositories/price-estimator/entities/house_info/HouseInfoItemV2Schema';
import { CollapsedBlock } from '../CollapsedBlock';
import { trackViewAllClick } from '../../containers/AboutHomeContainer/tracking';
import { EAnchorBlock } from '../../repositories/price-estimator/entities/onboardings/TooltipSchema';

export interface IAboutHomeProps {
  items: IHouseInfoItemV2Schema[];
  warningBanner: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export function AboutHome({ items, warningBanner, ref }: IAboutHomeProps): React.JSX.Element {
  const isDesktop = useIsDesktop();

  const itemsContent = (
    <div className={styles['content']}>
      {items.map(({ title, value }) => (
        <div className={styles['row']} key={title}>
          <div className={styles['name']}>
            <ArticleParagraph1 color="icon-secondary-default">{title}</ArticleParagraph1>
          </div>
          <div className={styles['val']}>
            <ArticleParagraph1 color="text-primary-default">{value}</ArticleParagraph1>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div id={EAnchorBlock.AboutHome} data-testid="AboutHome" ref={ref} className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
          О доме
        </ConditionalWrapper>
      </div>
      {warningBanner}
      {isDesktop ? (
        itemsContent
      ) : (
        <CollapsedBlock onClickCallback={trackViewAllClick} height={90}>
          {itemsContent}
        </CollapsedBlock>
      )}
    </div>
  );
}
